import React from 'react';
import { faLink } from '@fortawesome/free-solid-svg-icons';

import Icon from './Icon';

const LinkIcon = () => (
  <Icon tooltip="Link" iconObj={faLink} />
);

export default LinkIcon;